import { ConsultationsContextFactory } from './ConsultationsContextFactory';

export const consultationsContextDependencies = {
  patientConsultationsInteractor: ConsultationsContextFactory.patientConsultationsInteractor(),
};
